import React from "react";
import {
  Paper,
  Typography,
  Box,
  Divider,
  Collapse,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

export default function ScreenerExplanation() {
  const [open, setOpen] = React.useState(false);

  return (
    <Paper elevation={2} sx={{ mb: 3 }}>
      {/* Header */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        px={3}
        py={2}
      >
        <Typography variant="h6" fontWeight={700}>
          What do these filters mean?
        </Typography>

        <IconButton
          size="small"
          onClick={() => setOpen((prev) => !prev)}
          aria-label="toggle explanation"
        >
          {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <Divider />

        <Box px={3} py={2}>
          <Typography variant="body2" color="text.secondary" paragraph>
            This screener helps you identify stocks based on profitability,
            financial stability, and consistency over time. You can combine
            multiple filters to narrow down companies that match your
            investment criteria.
          </Typography>

          <Box display="flex" flexDirection="column" gap={1.5}>
            <Typography variant="body2">
              <strong>Market:</strong> Select the stock market you want to
              analyze.
            </Typography>

            <Typography variant="body2">
              <strong>Lookback Years:</strong> Defines how many past years of
              financial data are analyzed.
            </Typography>

            <Typography variant="body2">
              <strong>Profit Years:</strong> Minimum number of years with
              positive net income within the lookback period.
            </Typography>

            <Typography variant="body2">
              <strong>Profit Ratio:</strong> Minimum profit margin required.
            </Typography>

            <Typography variant="body2">
              <strong>Net Income (Min / Max):</strong> Filters companies by
              earnings level.
            </Typography>

            <Typography variant="body2">
              <strong>Debt / EBITDA:</strong> Measures financial leverage and
              risk.
            </Typography>
          </Box>

          <Divider sx={{ my: 2 }} />

          <Typography variant="body2" color="text.secondary">
            Only stocks that meet <strong>all</strong> selected criteria will be
            shown in the results.
          </Typography>
        </Box>
      </Collapse>
    </Paper>
  );
}
